import { render, staticRenderFns } from "./headerMenu.vue?vue&type=template&id=64c2ac3a&scoped=true&"
import script from "./headerMenu.vue?vue&type=script&lang=js&"
export * from "./headerMenu.vue?vue&type=script&lang=js&"
import style0 from "./headerMenu.vue?vue&type=style&index=0&id=64c2ac3a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c2ac3a",
  null
  
)

export default component.exports